import Tracking from './tracking';
import Social from './social';
import Video from './video';
import Lazy from './lazy';
import General from './general';
import RespContent from './resp-content';

function init() {
  Lazy.init();
  Video.init();
  General.init();
  RespContent.init();
  Lazy.init();
  Tracking.init();
  Social.init();
}

export default {
  init
}
